<template>
  <Form :associate="associate" @saveModel="$router.push('/admin/associates')"/>
</template>

<script>
  import Form from '@/components/admin/associates/Form'

  export default {
    components: { Form },
    data() {
      return {
        associate: {}
      }
    },
    name: 'New'
  }
</script>

<style scoped>

</style>